import React from "react";

function Button({
    onClick,
    text,
    paddingX = 'px-6',
    paddingY = 'py-2',
    color = 'bg-black',
    textColor = 'text-white',
    border = 'border-transparent',
    disableHover = false,
    textSize = 'text-base',
    fullWidth = false,
    rounded = 'rounded-lg',
    shadowBox = '' // Nuevo prop con valor por defecto vacío
}) {
    return (
        <button
            className={`${color} ${textColor} ${border} ${paddingX} ${paddingY} ${textSize} ${rounded} ${shadowBox} ${disableHover ? '' : 'hover:bg-gray-800'} border ${fullWidth ? 'w-full' : ''}`}
            onClick={onClick}
        >
            {text}
        </button>
    );
}

export default Button;
